import React, { type FC, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useAppContext } from '../contexts/App.context'
import { ShareButton } from '../ui/ShareButton'
import { generateBoxDeepLinkUrl } from '../utils/shareUtils'
import { trackBoxShared } from '../utils/amplitude'

export const BoxShareButton: FC<{
  boxId: number
  className?: string
  disabled?: boolean
  onSuccess?: () => void
  onError?: (error: Error) => void
}> = ({ boxId, className, disabled, onSuccess, onError }) => {
  const { referralKey } = useAppContext()
  const { formatMessage } = useIntl()

  const url = generateBoxDeepLinkUrl(boxId, referralKey ?? null)

  const shareText = formatMessage({
    id: 'box.share.text',
    defaultMessage: 'Посмотри на VoteBox!',
  })

  const handleSuccess = useCallback(() => {
    // Determine share method based on environment
    const hasTelegramShare =
      typeof window !== 'undefined' &&
      window.Telegram?.WebApp?.openTelegramLink !== undefined
    const hasWebShare =
      typeof navigator !== 'undefined' && 'share' in navigator
    const isNativeShare = hasTelegramShare || hasWebShare
    trackBoxShared(String(boxId), isNativeShare ? 'native' : 'clipboard')
    onSuccess?.()
  }, [boxId, onSuccess])

  return (
    <ShareButton
      url={url}
      text={shareText}
      className={className}
      disabled={disabled}
      onSuccess={handleSuccess}
      onError={onError}
    />
  )
}
